import React from 'react';
import { useNotifications } from '../../hooks/useNotifications';
import { Bell, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';

const NotificationDemo: React.FC = () => {
  const notifications = useNotifications();

  const handleSuccess = () => {
    notifications.success.login();
  };

  const handleError = () => {
    notifications.error.network();
  };

  const handleWarning = () => {
    notifications.warning.validation('Este é um exemplo de aviso');
  };

  const handleInfo = () => {
    notifications.info.loading('Carregando dados...');
  };

  const handleCustomSuccess = () => {
    notifications.showSuccess('Sucesso personalizado!', 'Esta é uma notificação de sucesso customizada.');
  };

  const handleCustomError = () => {
    notifications.showError('Erro personalizado!', 'Esta é uma notificação de erro customizada.');
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center mb-4">
        <Bell className="h-6 w-6 text-primary-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">Demonstração de Notificações</h3>
      </div>
      
      <p className="text-gray-600 mb-6">
        Clique nos botões abaixo para testar diferentes tipos de notificações:
      </p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {/* Sucesso */}
        <button
          onClick={handleSuccess}
          className="flex items-center justify-center px-4 py-3 bg-green-50 hover:bg-green-100 text-green-700 rounded-lg transition-colors duration-200"
        >
          <CheckCircle className="h-5 w-5 mr-2" />
          Sucesso
        </button>

        {/* Erro */}
        <button
          onClick={handleError}
          className="flex items-center justify-center px-4 py-3 bg-red-50 hover:bg-red-100 text-red-700 rounded-lg transition-colors duration-200"
        >
          <XCircle className="h-5 w-5 mr-2" />
          Erro
        </button>

        {/* Aviso */}
        <button
          onClick={handleWarning}
          className="flex items-center justify-center px-4 py-3 bg-yellow-50 hover:bg-yellow-100 text-yellow-700 rounded-lg transition-colors duration-200"
        >
          <AlertTriangle className="h-5 w-5 mr-2" />
          Aviso
        </button>

        {/* Informação */}
        <button
          onClick={handleInfo}
          className="flex items-center justify-center px-4 py-3 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-lg transition-colors duration-200"
        >
          <Info className="h-5 w-5 mr-2" />
          Informação
        </button>

        {/* Sucesso Personalizado */}
        <button
          onClick={handleCustomSuccess}
          className="flex items-center justify-center px-4 py-3 bg-primary-50 hover:bg-primary-100 text-primary-700 rounded-lg transition-colors duration-200"
        >
          <CheckCircle className="h-5 w-5 mr-2" />
          Sucesso Custom
        </button>

        {/* Erro Personalizado */}
        <button
          onClick={handleCustomError}
          className="flex items-center justify-center px-4 py-3 bg-secondary-50 hover:bg-secondary-100 text-secondary-700 rounded-lg transition-colors duration-200"
        >
          <XCircle className="h-5 w-5 mr-2" />
          Erro Custom
        </button>
      </div>

      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-2">Tipos de Notificações:</h4>
        <ul className="text-sm text-gray-600 space-y-1">
          <li><strong>Sucesso:</strong> Ações concluídas com sucesso</li>
          <li><strong>Erro:</strong> Problemas que impedem a ação</li>
          <li><strong>Aviso:</strong> Situações que requerem atenção</li>
          <li><strong>Informação:</strong> Dados e status do sistema</li>
        </ul>
      </div>
    </div>
  );
};

export default NotificationDemo;
